import * as React from 'react'
import { IMaskInput } from 'react-imask'
import { InterpolationValue } from 'styled-components'
import { rem, placeholder } from 'polished'

import { styled, css } from '$utils/theme'
import { Text } from '$views/components/Text'
import { Division } from '$views/components/Division'
import { verticalMarginsCss } from '$utils/theme/css'
import { Icon } from '$views/components/Icon'
import { Block } from '$views/components/Layout/Block'
import { InputIcon } from './InputIcon'
import { TextFontWeight } from '$utils/theme/font'

interface Props extends React.InputHTMLAttributes<any> {
  className?: string
  primary?: boolean
  secondary?: boolean
  small?: boolean
  success?: boolean
  error?: boolean
  errorText?: any
  icon?: string
  label?: string
  info?: boolean
  infoText?: string
  mini?: boolean
  weight?: TextFontWeight
  color?: string
  right?: boolean
  width?: number
}

const Wrapper = styled.div.attrs({})<Props>`
  position: relative;
  margin-bottom: ${p => rem(p.theme.sizes.mini)};
  ${verticalMarginsCss};
`

const StyledInput = styled(IMaskInput).attrs({})<Props>`
  width: ${p => (p.width ? p.width : 100)}%;
  padding: ${p => rem(p.theme.sizes.mini)};
  ${p => p.theme.font.base()};
  ${p => placeholder({ color: p.theme.colors.grey }) as InterpolationValue};

  &:focus {
    border-color: ${p => p.theme.colors.darkGrey};
    caret-color: ${p => p.theme.colors.darkGrey};
    outline: none;
  }

  ${p =>
    p.primary &&
    `
      color: ${p.theme.colors.darkGrey};
      height: ${rem(p.theme.sizes.large)};
      border: 1px solid ${p.theme.colors.lightGrey};
      border-radius: ${rem(30)};
    `};

  ${p =>
    p.secondary &&
    `
      color: ${p.theme.colors.darkGrey};
      height: ${rem(p.theme.sizes.small)};
      border: none;
      padding-left: ${p.theme.sizes.none};
      font-size: 1.25rem !important;
      font-weight: ${p.theme.fontWeight.medium};
      line-height:
    `};
  ${p =>
    p.small &&
    `
      padding-left: ${rem(p.theme.sizes.mini)};
      font-size: 1rem !important;
      font-weight: ${p.theme.fontWeight.regular};
    `};

  ${p =>
    p.success &&
    css`
      border-color: ${p.theme.colors.semanticGreen};
    `};
  ::-ms-clear {
    display: none;
  }

  ${p =>
    p.type === 'number' &&
    css`
      padding: 0 ${rem(p.theme.sizes.mini)};
    `} ${p =>
    p.success &&
    css`
      border-color: ${p.theme.colors.semanticGreen};
    `};
  ::-ms-clear {
    display: none;
  }

  ${p =>
    p.type === 'password' &&
    css`
      ::-webkit-input-placeholder {
        letter-spacing: normal;
      }
      ::-moz-placeholder {
        letter-spacing: normal;
      }
      ::placeholder {
        letter-spacing: normal;
      }
      letter-spacing: 0.3rem;
    `} ${p =>
    p.right &&
    css`
      text-align: right;
    `};
`
const StyledIcon = styled(Icon)`
  width: ${rem(60)};
  margin-right: ${p => rem(p.theme.sizes.small)};
`
export const ErrorText = styled(Text)<Props>`
  color: ${p =>
    (p.color && p.theme.colors[p.color]) ||
    (p.error && p.theme.colors.darkPink) ||
    (p.success && p.theme.colors.semanticGreen)};
  margin-top: ${p => rem(p.theme.sizes.tiny)};
`
export const Input: React.SFC<Props> = props => {
  const color = props.error ? 'darkPink' : 'lightGrey'
  return (
    <Wrapper>
      {props.secondary && (
        <Text marginTop={props.small ? 'base' : 'small'} marginBottom="base" weight="medium">
          {props.label}
        </Text>
      )}
      {(!!props.icon || props.error || props.success) && props.primary && (
        <InputIcon icon={props.icon} error={props.error} success={props.success} />
      )}
      {props.info && (
        <Block flex justify="between" marginTop="base" marginBottom="mini">
          <Text weight="light" as="span" marginRight="base">
            {props.infoText}
          </Text>
          <StyledIcon content={props.icon} size="xl" />
        </Block>
      )}
      <StyledInput {...props} />
      {(props.error || props.success) && (
        <ErrorText
          as="p"
          caption
          error={props.error}
          success={props.success}
          className={props.className}
          color={props.color}
        >
          {props.errorText}
        </ErrorText>
      )}
      {props.secondary && !props.small && <Division marginTop={props.error ? 'tiny' : 'small'} color={color} />}
      {props.secondary && props.small && <Division marginTop={props.error ? 'tiny' : 'base'} color={color} />}
    </Wrapper>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/Input/Input.tsx